import IResponse from '../interfaces/IResponse';
import axios, { AxiosRequestConfig } from 'axios';
import ApiHelper from './ApiHelper';
import { baseURL } from '../config';

const BASE_URL = `${baseURL}api/viewCounter`;


interface IGetViews extends IResponse {
    views: any[] | null,
    weeklyViews: number | null,
    monthlyViews: number | null,
    viewCount: number | null,
    dailyStatsPerYear: any[] | null,
    hourlyStatsPerYear: any[] | null,
    hourlyStatsPerDayByYear: any[] | null,
    monthlyStatsFromAllYears: any[] | null,
}

export interface IFurnitureViewRankingItem {
    furnitureId: string;
    name: string;
    producer: string;
    collection: string;
    views: number;
    lastViewedAt: string;
}

export interface IFurnitureViewTimelineItem {
    date: string;
    views: number;
}

export interface IFurnitureViewEvent {
    id: string;
    furnitureId: string;
    name: string;
    producer: string;
    collection: string;
    viewedAt: string;
}

export interface IFurnitureViewStatistics extends IResponse {
    range: { from: string; to: string } | null;
    summary: { views: number; uniqueFurniture: number } | null;
    ranking: IFurnitureViewRankingItem[];
    timeline: IFurnitureViewTimelineItem[];
    events: IFurnitureViewEvent[];
}

const getStatisticsData = async (): Promise<IGetViews> => {
    const url = `${baseURL}api/viewsData`;
    const header: AxiosRequestConfig = {
        headers: ApiHelper.createHeader(),
    }
    
    try {
        const res = await axios.get(url, header)

        const resoult = {
            message: 'Pobrano wyświetlenia',
            ok: true,
            status: res.status,
            views: res.data.views,
            weeklyViews: res.data.weeklyViews,
            monthlyViews: res.data.monthlyViews,
            viewCount: res.data.viewCount,
            dailyStatsPerYear: res.data.dailyStatsPerYear,
            hourlyStatsPerYear: res.data.hourlyStatsPerYear,
            hourlyStatsPerDayByYear: res.data.hourlyStatsPerDayByYear,
            monthlyStatsFromAllYears: res.data.monthlyStatsFromAllYears,
        }

        return resoult;
    } catch (error) {

         let message = 'Nie pobrano wyświetleń'
         let status = 400

         if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie możesz tego zrobić'
            if (error.response.status) status = error.response.status
         }

         return {
            message,
            status,
            ok: false,
            views: null,
            weeklyViews: null,
            monthlyViews: null,
            viewCount: null,
            dailyStatsPerYear: null,
            hourlyStatsPerYear: null,
            hourlyStatsPerDayByYear: null,
            monthlyStatsFromAllYears: null,
         }
    }
}


interface IGetCountsValue extends IResponse {
    counts: number | null,
}


const getCounts = async (): Promise<IGetCountsValue> => {
    const url = BASE_URL;

    const header: AxiosRequestConfig = {
        headers: ApiHelper.createHeader(),
    }

    try {
        const res = await axios.get(url, header)

        const resoult = {
            message: 'Pobrano wyświetlenia',
            ok: true,
            status: res.status,
            counts: res.data.counts
        }

        return resoult;
    } catch (error) {

         let message = 'Nie pobrano wyświetleń'
         let status = 400

         if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie możesz tego zrobić'
            if (error.response.status) status = error.response.status
         }

         return {
            message,
            status,
            ok: false,
            counts: null,
         }
    }
}

const newView = async () => {
    const response = await axios.post(`${BASE_URL}`)
    return response;
}

const getFurnitureViewStatistics = async (from: string, to: string): Promise<IFurnitureViewStatistics> => {
    try {
        const res = await axios.get(`${baseURL}api/furnitureViewStatistics`, {
            headers: ApiHelper.createHeader(),
            params: { from, to, limit: 500 },
        });
        return {
            message: 'Pobrano statystyki mebli',
            ok: true,
            status: res.status,
            range: res.data.range,
            summary: res.data.summary,
            ranking: res.data.ranking || [],
            timeline: res.data.timeline || [],
            events: res.data.events || [],
        };
    } catch (error) {
        let status = 400;
        let message = 'Nie udało się pobrać statystyk mebli';
        if (axios.isAxiosError(error) && error.response) {
            status = error.response.status;
            message = error.response.data?.message || message;
        }
        return { message, status, ok: false, range: null, summary: null, ranking: [], timeline: [], events: [] };
    }
}

const viewCounterController = {
    getCounts,
    newView,
    getStatisticsData,
    getFurnitureViewStatistics,
};

export default viewCounterController;
